<pxc-examination-content
  class="-mx-(--dialog-padding) -mb-(--dialog-padding) border-t border-border-secondary [--examination-inset:var(--dialog-padding)]"
  data-testid="examination-dialog-content"
  [isInDialog]="true" />
